export const i18nCode = () => `
export default {

}
// import ar from "../i18n/ar";
// import en from "../i18n/en";
// import { useI18n } from "vue-i18n";
// const { t } = useI18n({
//   messages: {
//     en: en,
//     ar: ar,
//   },
// }); 
`